import { Component, OnInit, Input, Inject, PLATFORM_ID } from '@angular/core';
import { Entry } from 'contentful';
import { FunctionsService } from '../../services/functions/functions.service';
import { Observable, combineLatest } from 'rxjs';
import { map, first, startWith } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { LocalizationService } from '../../services/localization/localization.service';
import { ProfileService } from '../../services/profile/profile.service';
import { AuthService } from '../../services/auth/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss']
})
export class InviteComponent implements OnInit {
  @Input() public content: Entry<any>;
  @Input() public smallerImage = false;
  @Input() public backgroundColor = '#FFFFFF';
  @Input() public iconBackgroundColor: string;

  public someChannels = [];
  public currentSomeChannelIndex = 0;
  public linkToShare$: Observable<string>;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private fnService: FunctionsService,
    private localizationService: LocalizationService,
    private profileService: ProfileService,
    private activatedRoute: ActivatedRoute
  ) {
    this.linkToShare$ = this.getShareUrl();
  }

  get currentSomeChannel() {
    return this.someChannels[this.currentSomeChannelIndex];
  }

  get host() {
    if (this.localizationService.locale.getValue() !== 'en-US') {
      return (
        environment.host + '/' + this.localizationService.locale.getValue()
      );
    } else {
      return environment.host;
    }
  }

  private getShareUrl() {
    const firstName$ = this.profileService.user().pipe(
      first(),
      map(user => user.firstName)
    );

    const id$ = this.fnService.hashId().pipe(first());

    return combineLatest(id$, firstName$).pipe(
      map(
        value =>
          this.host +
          '?invite=' +
          value[0] +
          '&first_name=' +
          encodeURIComponent(value[1])
      ),
      startWith(this.host + '?invite')
    );
  }

  ngOnInit() {
    if (this.content) {
      this.someChannels = this.content.fields.someChannels;
    }

    if (isPlatformBrowser(this.platformId)) {
      setInterval(() => {
        this.currentSomeChannelIndex = this.currentSomeChannelIndex + 1;
        if (this.currentSomeChannelIndex >= this.someChannels.length) {
          this.currentSomeChannelIndex = 0;
        }
      }, 3000);
    }
  }

  ngAfterViewInit() {
    this.activatedRoute.fragment.subscribe((fragment: string) => {
      if (fragment == 'invite-your-friends') {
        const newsletterElement = document.querySelector('app-invite');

        if (newsletterElement) {
          setTimeout(() => {
            newsletterElement.scrollIntoView();
          }, 1000);
        }
      }
    });
  }
}
